<template>
  <div class="content">
    <!-- start of title -->
    <div class="title-box">
      <el-button type="default" size="small" @click="$router.go(-1)">返回</el-button>
      <span>代征平台首次维护</span>
    </div>
    <!-- end of title -->

    <el-form :model="formData" :rules="formRules" ref="formData" label-width="150px">
      <!-- start of 合同信息 -->
      <div class="back-color-fff form-box">
        <span class="form-title">合同信息</span>
        <div class="form-item-box">
          <el-row>
            <el-col :span="12">
              <!-- 公司名称 -->
              <el-form-item label="公司名称" prop="tenantName">
                <el-select
                  clearable
                  size="small"
                  :disabled="guid ? true : false"
                  filterable
                  v-model="formData.tenantName"
                  placeholder="请选择"
                  @change="changeTenant"
                >
                  <el-option
                    v-for="(item, index) in tenantList"
                    :key="item.guid"
                    :label="item.tenantName"
                    :value="item.guid"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <!-- 公司简称 -->
              <el-form-item label="公司简称" prop="abbreviation">
                <el-input
                  placeholder="请输入"
                  :maxlength="50"
                  size="small"
                  min="0"
                  v-model="formData.abbreviation"
                ></el-input>
              </el-form-item>
            </el-col>

            <el-col :span="12">
              <!-- 合同名称 -->
              <el-form-item label="合同名称" prop="contractGuid">
                <el-select
                  clearable
                  size="small"
                  :disabled="guid ? true : false"
                  filterable
                  v-model="formData.contractGuid"
                  placeholder="请选择"
                  @change="changeContract"
                >
                  <el-option
                    v-for="(item, index) in contractList"
                    :key="item.guid"
                    :label="item.contractName"
                    :value="item.guid"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>

            <el-col :span="12">
              <!-- 签约企业 -->
              <el-form-item label="签约企业">
                <el-input
                  type="text"
                  disabled
                  placeholder="请输入"
                  size="small"
                  min="0"
                  v-model="contractVO.tenantName"
                ></el-input>
              </el-form-item>
            </el-col>

            <el-col :span="12">
              <!-- 公司成立时间 -->
              <el-form-item label="公司成立时间" prop="levyEnterprise.establishDate">
                <el-date-picker
                  size="small"
                  placeholder="请选择"
                  value-format="yyyy-MM-dd"
                  v-model="formData.levyEnterprise.establishDate"
                ></el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <!-- 注册资本(万元) -->
              <el-form-item label="注册资本(万元)" prop="levyEnterprise.registeredCapital">
                <el-input
                  type="text"
                  :maxlength="10"
                  oninput="value=value.replace(/[^\d.]/g, '').replace(/\.{2,}/g, '.').replace('.', '$#$').replace(/\./g, '').replace('$#$', '.').replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3').replace(/^\./g, '')"
                  placeholder="请输入"
                  size="small"
                  min="0"
                  v-model="formData.levyEnterprise.registeredCapital"
                ></el-input>
              </el-form-item>
            </el-col>

            <el-col :span="12">
              <!-- 公司组织形式 -->
              <el-form-item label="公司组织形式" prop="levyEnterprise.enterpriseCate">
                <el-select
                  size="small"
                  clearable
                  filterable
                  v-model="formData.levyEnterprise.organizationForm"
                  placeholder="请选择"
                >
                  <el-option
                    v-for="(item, index) in getCodeListByKey('公司组织形式')"
                    :key="index"
                    :label="item.text"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>

            <el-col :span="12">
              <!-- 业务联系人 -->
              <el-form-item label="业务联系人" prop="contacts">
                <el-input
                  oninput="if(value.length>10)value=value.slice(0, 10)"
                  placeholder="请填写"
                  size="small"
                  type="text"
                  v-model="formData.contacts"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <!-- 是否实缴 -->
              <el-form-item label="是否实缴" prop="levyEnterprise.isPaidIn">
                <el-radio-group v-model="formData.levyEnterprise.isPaidIn">
                  <el-radio label="Y">是</el-radio>
                  <el-radio label="N">否</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <!-- 联系电话 -->
              <el-form-item label="业务联系人电话" prop="contactTel">
                <el-input
                  type="text"
                  onkeyup="value=value.replace(/[^0-9]/g,'')"
                  :maxlength="11"
                  placeholder="请输入"
                  size="small"
                  v-model="formData.contactTel"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <!-- 证照年审是否正常 -->
              <el-form-item label="证照年审是否正常" prop="levyEnterprise.annualReviewState">
                <el-radio-group v-model="formData.levyEnterprise.annualReviewState">
                  <el-radio label="Y">是</el-radio>
                  <el-radio label="N">否</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>

            <el-col :span="12">
              <!-- 是否垫资 -->
              <el-form-item label="是否垫资" prop="levyEnterprise.isAdvanceMoney">
                <el-radio-group v-model="formData.levyEnterprise.isAdvanceMoney">
                  <el-radio label="Y">是</el-radio>
                  <el-radio label="N">否</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>

            <!-- 合作税率 -->
            <!-- <el-col :span="12">
              <el-form-item label="合作税率(%)" prop="levyEnterprise.cooperationTaxRate">
                <el-input type="text" :maxlength="12" oninput="value=value.replace(/[^\d.]/g, '').replace(/\.{2,}/g, '.').replace('.', '$#$').replace(/\./g, '').replace('$#$', '.').replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3').replace(/^\./g, '')" placeholder="请输入" size="small" v-model="formData.levyEnterprise.cooperationTaxRate">
                </el-input>
              </el-form-item>
            </el-col> -->

            <!-- 费用类型 -->
            <el-col :span="12">
              <el-form-item label="费用类型" prop="expenseType">
                <el-select
                  size="small"
                  clearable
                  filterable
                  v-model="formData.expenseType"
                  placeholder="请选择"
                  @change="expenseTypeChange"
                >
                  <el-option
                    v-for="(item, index) in expenseTypeList"
                    :key="index"
                    :label="item.text"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <!-- 显示不同的费用类型 ----1: SAAS服务费率 值是百分比 -->
            <el-col :span="12" v-if="formData.expenseType == '1'">
              <el-form-item label="SAAS服务费率(%)" prop="levyEnterprise.cooperationTaxRate">
                <el-input
                  type="text"
                  :maxlength="12"
                  oninput="value=value.replace(/[^\d.]/g, '').replace(/\.{2,}/g, '.').replace('.', '$#$').replace(/\./g, '').replace('$#$', '.').replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3').replace(/^\./g, '')"
                  placeholder="请输入"
                  size="small"
                  v-model="formData.levyEnterprise.cooperationTaxRate"
                >
                </el-input>
              </el-form-item>
            </el-col>
            <!-- 显示不同的费用类型 ----2：SAAS服务费 值是金额  单位万元 -->
            <el-col :span="12" v-if="formData.expenseType == '2'">
              <el-form-item label="SAAS服务费(万元)" prop="levyEnterprise.costMoney">
                <el-input
                  type="text"
                  :maxlength="12"
                  oninput="value=value.replace(/[^\d.]/g, '').replace(/\.{2,}/g, '.').replace('.', '$#$').replace(/\./g, '').replace('$#$', '.').replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3').replace(/^\./g, '')"
                  placeholder="请输入"
                  size="small"
                  v-model="formData.levyEnterprise.costMoney"
                >
                </el-input>
              </el-form-item>
            </el-col>

            <el-col :span="12">
              <!-- 合同有效期至 -->
              <el-form-item label="合同有效期至" prop="levyEnterprise.cooperationValidityDate">
                <el-date-picker
                  size="small"
                  placeholder="请选择"
                  value-format="yyyy-MM-dd"
                  v-model="formData.levyEnterprise.cooperationValidityDate"
                ></el-date-picker>
              </el-form-item>
            </el-col>

            <el-col :span="12">
              <!-- 月度合作上限(元) -->
              <el-form-item label="月度合作上限(元)" prop="levyEnterprise.monthMaxMoney">
                <el-input
                  type="text"
                  :maxlength="12"
                  oninput="value=value.replace(/[^\d.]/g, '').replace(/\.{2,}/g, '.').replace('.', '$#$').replace(/\./g, '').replace('$#$', '.').replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3').replace(/^\./g, '')"
                  placeholder="请输入"
                  size="small"
                  v-model="formData.levyEnterprise.monthMaxMoney"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <!-- 开票类型 -->
              <el-form-item label="开票类型" prop="levyEnterprise.invoiceType">
                <el-select
                  size="small"
                  clearable
                  filterable
                  multiple
                  collapse-tags
                  v-model="formData.levyEnterprise.invoiceType"
                  placeholder="请选择"
                >
                  <el-option
                    v-for="(item, index) in billingTypeList"
                    :key="index"
                    :label="item.text"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>

            <el-col :span="12">
              <!-- 介绍人 -->
              <el-form-item label="介绍人" prop="levyEnterprise.introducer">
                <el-input
                  type="text"
                  :maxlength="10"
                  placeholder="请输入"
                  size="small"
                  v-model="formData.levyEnterprise.introducer"
                ></el-input>
              </el-form-item>
            </el-col>
            <!-- 服务类型 -->
            <!-- <el-col :span="12">
              <el-form-item label="服务类型" prop="levyEnterprise.serviceType">
                <el-select size="small" clearable filterable v-model="formData.levyEnterprise.serviceType" placeholder="请选择">
                  <el-option
                    v-for="(item, index) in servesTypeList"
                    :key="index"
                    :label="item.text"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col> -->

            <el-col :span="12">
              <!-- 联系电话 -->
              <el-form-item label="介绍人电话" prop="levyEnterprise.introducerTel">
                <el-input
                  type="text"
                  onkeyup="value=value.replace(/[^0-9]/g,'')"
                  :maxlength="11"
                  placeholder="请输入"
                  size="small"
                  v-model="formData.levyEnterprise.introducerTel"
                ></el-input>
              </el-form-item>
            </el-col>
            <!-- 税号\公司地址\公司电话 start -->
            <!-- //!编辑局部 -->
            <template v-if="$route.query.guid">
              <template v-if="!formData.expenseType">
                <!-- 公司地址 -->
                <el-col :span="12">
                  <el-form-item label="公司地址">
                    <el-cascader
                      size="small"
                      ref="cascaderFirst"
                      style="width: 314px"
                      @change="incres"
                      :options="options"
                      v-model="addressList"
                      clearable
                      filterable
                    >
                    </el-cascader>
                  </el-form-item>
                </el-col>

                <!-- 税号 -->
                <el-col :span="12">
                  <el-form-item label="税号" prop="taxpayerId">
                    <el-input size="small" placeholder="请输入" v-model="formData.taxpayerId"> </el-input>
                  </el-form-item>
                </el-col>

                <!-- 详细地址 -->
                <el-col :span="12">
                  <el-form-item label="" prop="address">
                    <span slot="label">详细地址 </span>
                    <el-input
                      type="textarea"
                      style="width: 314px"
                      v-model="formData.address"
                      placeholder="请输入详细地址"
                      clearable
                    >
                    </el-input>
                  </el-form-item>
                </el-col>

                <!-- 公司电话 -->
                <el-col :span="12">
                  <el-form-item label="公司电话" prop="tel">
                    <el-input
                      type="text"
                      @blur="checkPhone(formData.tel)"
                      :maxlength="13"
                      placeholder="请输入"
                      size="small"
                      v-model="formData.tel"
                    ></el-input>
                  </el-form-item>
                </el-col>
              </template>
              <template v-else>
                <!-- 税号 -->
                <el-col :span="12">
                  <el-form-item label="税号" prop="taxpayerId">
                    <el-input size="small" placeholder="请输入" v-model="formData.taxpayerId"> </el-input>
                  </el-form-item>
                </el-col>

                <!-- 公司地址 -->
                <el-col :span="12">
                  <el-form-item label="公司地址">
                    <el-cascader
                      size="small"
                      ref="cascaderFirst"
                      style="width: 314px"
                      @change="incres"
                      :options="options"
                      v-model="addressList"
                      clearable
                      filterable
                    >
                    </el-cascader>
                  </el-form-item>
                </el-col>

                <!-- 公司电话 -->
                <el-col :span="12">
                  <el-form-item label="公司电话" prop="tel">
                    <el-input
                      type="text"
                      @blur="checkPhone(formData.tel)"
                      :maxlength="13"
                      placeholder="请输入"
                      size="small"
                      v-model="formData.tel"
                    ></el-input>
                  </el-form-item>
                </el-col>

                <!-- 详细地址 -->
                <el-col :span="12">
                  <el-form-item label="" prop="address">
                    <span slot="label">详细地址 </span>
                    <el-input
                      type="textarea"
                      style="width: 314px"
                      v-model="formData.address"
                      placeholder="请输入详细地址"
                      clearable
                    >
                    </el-input>
                  </el-form-item>
                </el-col>
              </template>
            </template>
            <!-- //!新增局部 -->
            <template v-else>
              <template v-if="!formData.expenseType">
                <!-- 公司地址 -->
                <el-col :span="12">
                  <el-form-item label="公司地址">
                    <el-cascader
                      size="small"
                      ref="cascaderFirst"
                      style="width: 314px"
                      @change="incres"
                      :options="options"
                      v-model="addressList"
                      clearable
                      filterable
                    >
                    </el-cascader>
                  </el-form-item>
                </el-col>

                <!-- 税号 -->
                <el-col :span="12">
                  <el-form-item label="税号" prop="taxpayerId">
                    <el-input size="small" placeholder="请输入" v-model="formData.taxpayerId"> </el-input>
                  </el-form-item>
                </el-col>

                <!-- 详细地址 -->
                <el-col :span="12">
                  <el-form-item label="" prop="address">
                    <span slot="label">详细地址 </span>
                    <el-input
                      type="textarea"
                      style="width: 314px"
                      v-model="formData.address"
                      placeholder="请输入详细地址"
                      clearable
                    >
                    </el-input>
                  </el-form-item>
                </el-col>

                <!-- 公司电话 -->
                <el-col :span="12">
                  <el-form-item label="公司电话" prop="tel">
                    <el-input
                      type="text"
                      @blur="checkPhone(formData.tel)"
                      :maxlength="13"
                      placeholder="请输入"
                      size="small"
                      v-model="formData.tel"
                    ></el-input>
                  </el-form-item>
                </el-col>
              </template>
              <template v-else>
                <!-- 税号 -->
                <el-col :span="12">
                  <el-form-item label="税号" prop="taxpayerId">
                    <el-input size="small" placeholder="请输入" v-model="formData.taxpayerId"> </el-input>
                  </el-form-item>
                </el-col>

                <!-- 公司地址 -->
                <el-col :span="12">
                  <el-form-item label="公司地址">
                    <el-cascader
                      size="small"
                      ref="cascaderFirst"
                      style="width: 314px"
                      @change="incres"
                      :options="options"
                      v-model="addressList"
                      clearable
                      filterable
                    >
                    </el-cascader>
                  </el-form-item>
                </el-col>

                <!-- 公司电话 -->
                <el-col :span="12">
                  <el-form-item label="公司电话" prop="tel">
                    <el-input
                      type="text"
                      @blur="checkPhone(formData.tel)"
                      :maxlength="13"
                      placeholder="请输入"
                      size="small"
                      v-model="formData.tel"
                    ></el-input>
                  </el-form-item>
                </el-col>

                <!-- 详细地址 -->
                <el-col :span="12">
                  <el-form-item label="" prop="address">
                    <span slot="label">详细地址 </span>
                    <el-input
                      type="textarea"
                      style="width: 314px"
                      v-model="formData.address"
                      placeholder="请输入详细地址"
                      clearable
                    >
                    </el-input>
                  </el-form-item>
                </el-col>
              </template>
            </template>
            <!-- 税号\公司地址\公司电话 end -->
            <!-- 人均服务费(元) -->
            <!-- <el-col :span="12">
              <el-form-item v-if="formData.levyEnterprise.serviceType == '9903'" label="人均服务费(元)" prop="levyEnterprise.avgServiceCost">
                <el-input type="text" :maxlength="12" placeholder="请输入" oninput="value=value.replace(/[^\d.]/g, '').replace(/\.{2,}/g, '.').replace('.', '$#$').replace(/\./g, '').replace('$#$', '.').replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3').replace(/^\./g, '')" size="small" v-model="formData.levyEnterprise.avgServiceCost"></el-input>
              </el-form-item>
            </el-col> -->
          </el-row>
          <!-- 营业执照 -->
          <el-form-item label="营业执照">
            <div class="file-list-box">
              <el-upload
                class="upload-file-box"
                action="#"
                :limit="1"
                :on-exceed="handleExceed"
                :accept="acceptFile"
                :on-remove="removeBusinessList"
                :http-request="uploadBusinesslicense"
                :file-list="businesslicenseList"
                :beforeUpload="beforeAvatarUpload"
              >
                <div class="import-btn-tips">
                  <el-button size="mini" icon="el-icon-my-import" style="margin-bottom: 0" type="importNew"
                    >上传文件</el-button
                  >
                  <div class="import-step-tip">{{ tips }}</div>
                </div>
              </el-upload>

              <div class="btn-box" v-if="businesslicenseList && businesslicenseList.length > 0">
                <a
                  :href="businesslicenseList[0].path + '?response-content-type=application/octet-stream'"
                  style="text-decoration: underline; cursor: pointer; color: #4fa1a4"
                  :download="businesslicenseList[0].name"
                  class="downFile"
                  >点击下载</a
                >
                <a
                  @click="seeDetail(businesslicenseList[0].path, businesslicenseList[0].name)"
                  style="text-decoration: underline; cursor: pointer; color: #4fa1a4; margin-left: 20px"
                  download="FileName"
                  class="downFile"
                  >点击查看</a
                >
              </div>
            </div>
          </el-form-item>
          <!-- 代征资质 -->
          <el-form-item label="代征资质">
            <div class="file-list-box">
              <el-upload
                class="upload-file-box"
                action="#"
                :limit="1"
                :on-exceed="handleExceed"
                :accept="acceptFile"
                :on-remove="removeAgentList"
                :http-request="uploadAgent"
                :file-list="agentList"
                :beforeUpload="beforeAvatarUpload"
              >
                <div class="import-btn-tips">
                  <el-button size="mini" icon="el-icon-my-import" style="margin-bottom: 0" type="importNew"
                    >上传文件</el-button
                  >
                  <div class="import-step-tip">{{ tips }}</div>
                </div>
              </el-upload>
              <div class="btn-box" v-if="agentList && agentList.length > 0">
                <a
                  :href="agentList[0].path + '?response-content-type=application/octet-stream'"
                  style="text-decoration: underline; cursor: pointer; color: #4fa1a4"
                  :download="agentList[0].name"
                  class="downFile"
                  >点击下载</a
                >
                <a
                  @click="seeDetail(agentList[0].path, agentList[0].name)"
                  style="text-decoration: underline; cursor: pointer; color: #4fa1a4; margin-left: 20px"
                  download="FileName"
                  class="downFile"
                  >点击查看</a
                >
              </div>
            </div>
          </el-form-item>
        </div>
      </div>
      <!-- end of 合同信息 -->

      <!-- start of 证件信息 -->
      <div class="back-color-fff form-box">
        <span class="form-title">证件信息</span>
        <div class="form-item-box">
          <!-- 完税证明 -->
          <el-form-item label="完税证明" prop="levyEnterprise.taxPaymentCertificateDate">
            <el-select
              size="small"
              clearable
              v-model="formData.levyEnterprise.taxPaymentCertificateDate"
              placeholder="请选择"
            >
              <el-option v-for="(item, index) in monthsList" :key="index" :label="item.text" :value="item.value">
              </el-option>
            </el-select>
            <div class="file-list-box">
              <el-upload
                class="upload-file-box"
                action="#"
                :limit="1"
                :on-exceed="handleExceed"
                :accept="acceptFile"
                :on-remove="removeTaxPaymentList"
                :http-request="uploadTaxPayment"
                :file-list="taxPaymentList"
                :beforeUpload="beforeAvatarUpload"
              >
                <div class="import-btn-tips">
                  <el-button size="mini" icon="el-icon-my-import" style="margin-bottom: 0" type="importNew"
                    >上传文件</el-button
                  >
                  <div class="import-step-tip">{{ tips }}</div>
                </div>
              </el-upload>

              <div class="btn-box" v-if="taxPaymentList && taxPaymentList.length > 0">
                <a
                  :href="taxPaymentList[0].path + '?response-content-type=application/octet-stream'"
                  style="text-decoration: underline; cursor: pointer; color: #4fa1a4"
                  :download="taxPaymentList[0].name"
                  class="downFile"
                  >点击下载</a
                >
                <a
                  @click="seeDetail(taxPaymentList[0].path, taxPaymentList[0].name)"
                  style="text-decoration: underline; cursor: pointer; color: #4fa1a4; margin-left: 20px"
                  download="FileName"
                  class="downFile"
                  >点击查看</a
                >
              </div>
            </div>
          </el-form-item>
          <!-- 个税扣缴明细 -->
          <el-form-item label="个税扣缴明细" prop="levyEnterprise.privateTaxDetailDate">
            <el-select
              size="small"
              clearable
              v-model="formData.levyEnterprise.privateTaxDetailDate"
              placeholder="请选择"
            >
              <el-option v-for="(item, index) in monthsList" :key="index" :label="item.text" :value="item.value">
              </el-option>
            </el-select>
            <div class="file-list-box">
              <el-upload
                class="upload-file-box"
                action="#"
                :limit="1"
                :on-exceed="handleExceed"
                :accept="acceptFile"
                :on-remove="removePrivateTaxList"
                :http-request="uploadPrivateTax"
                :file-list="privateTaxList"
                :beforeUpload="beforeAvatarUpload"
              >
                <div class="import-btn-tips">
                  <el-button size="mini" icon="el-icon-my-import" style="margin-bottom: 0" type="importNew"
                    >上传文件</el-button
                  >
                  <div class="import-step-tip">{{ tips }}</div>
                </div>
              </el-upload>
              <div class="btn-box" v-if="privateTaxList && privateTaxList.length > 0">
                <a
                  :href="privateTaxList[0].path + '?response-content-type=application/octet-stream'"
                  style="text-decoration: underline; cursor: pointer; color: #4fa1a4"
                  :download="privateTaxList[0].name"
                  class="downFile"
                  >点击下载</a
                >
                <a
                  @click="seeDetail(privateTaxList[0].path, privateTaxList[0].name)"
                  style="text-decoration: underline; cursor: pointer; color: #4fa1a4; margin-left: 20px"
                  download="FileName"
                  class="downFile"
                  >点击查看</a
                >
              </div>
            </div>
          </el-form-item>
          <!-- 是否提供担保 -->
          <el-form-item label="是否提供担保" prop="levyEnterprise.isGuarantee">
            <el-radio-group v-model="formData.levyEnterprise.isGuarantee">
              <el-radio label="Y">可</el-radio>
              <el-radio label="N">不可</el-radio>
            </el-radio-group>
            <div class="file-list-box">
              <el-upload
                class="upload-file-box"
                v-if="formData.levyEnterprise.isGuarantee == 'Y'"
                action="#"
                :limit="1"
                :on-exceed="handleExceed"
                :accept="acceptFile"
                :on-remove="removeIsGuaranteeList"
                :http-request="uploadIsGuarantee"
                :file-list="isGuaranteeList"
                :beforeUpload="beforeAvatarUpload"
              >
                <div class="import-btn-tips">
                  <el-button size="mini" icon="el-icon-my-import" style="margin-bottom: 0" type="importNew"
                    >上传文件</el-button
                  >
                  <div class="import-step-tip">{{ tips }}</div>
                </div>
              </el-upload>
              <div class="btn-box" v-if="isGuaranteeList && isGuaranteeList.length > 0">
                <a
                  :href="isGuaranteeList[0].path + '?response-content-type=application/octet-stream'"
                  style="text-decoration: underline; cursor: pointer; color: #4fa1a4"
                  :download="isGuaranteeList[0].name"
                  class="downFile"
                  >点击下载</a
                >
                <a
                  @click="seeDetail(isGuaranteeList[0].path, isGuaranteeList[0].name)"
                  style="text-decoration: underline; cursor: pointer; color: #4fa1a4; margin-left: 20px"
                  download="FileName"
                  class="downFile"
                  >点击查看</a
                >
              </div>
            </div>
          </el-form-item>
        </div>
      </div>
      <!-- end of 证件信息 -->

      <!-- start of 新增合作银行银行信息 -->
      <div class="back-color-fff form-box">
        <div class="form-box-title">
          <span class="form-title">合作银行信息</span>
          <span class="form-title sub-operate-add" @click="openBankList">新增代征平台银行信息</span>
        </div>
        <div class="form-item-box" v-for="(item, index) in formData.bankList" :key="index">
          <div class="sub-title-cooperate">
            银行信息{{ index + 1 }}
            <span class="sub-operate-add" @click="addCooperateBankItem">新增服务商合作银行</span>
            <span class="sub-operate-add" @click="delCooperateBankItem(index)">删除</span>
          </div>
          <el-row>
            <el-col :span="12">
              <!-- 账户类型-->
              <el-form-item label="银行名称" required>
                <el-select
                  size="small"
                  @focus="getBankList"
                  @change="selectBank(item.guid, index)"
                  v-model="item.guid"
                  placeholder="请选择"
                >
                  <el-option
                    v-for="(bankItem, bankIndex) in cooperateBank"
                    :key="bankIndex"
                    :label="bankItem.bankName"
                    :value="bankItem.guid"
                  >
                    <span style="float: left; margin-right: 20px">{{ bankItem.bankName }}</span>
                    <span style="float: right">{{ bankItem.bankAccount }}</span>
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <!-- 银行名称 -->
              <el-form-item label="银行卡号">
                <!-- <span class="el-input__inner el-input--small">{{item.bankAccount || '-'}}</span> -->
                <el-input disabled size="small" type="text" v-model="item.bankAccount" :maxlength="100"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <!-- 银行卡号 -->
              <el-form-item label="账户类型">
                <!-- <span class="el-input__inner el-input--small">{{item.accountType | accountTypeFilter}}</span> -->
                <el-input disabled size="small" type="text" v-model="item.accountTypeName"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </div>
        <div class="bottom-btn-box">
          <el-button type="defalut" size="small" @click="$router.go(-1)">取消</el-button>
          <el-button type="primary" size="small" @click="submitForm()">保存</el-button>
        </div>
      </div>
      <!-- end of 银行信息 -->

      <!-- 新增银行信息弹框 start -->
      <el-dialog title="新增代征平台银行信息" :visible.sync="addBankDialogVisible" width="60%">
        <div class="back-color-fff form-box-add">
          <div class="bank-list">
            <div class="form-item-box" v-for="(item, index) in basicBankList" :key="index">
              <div class="sub-title">
                银行信息{{ index + 1 }}
                <span class="sub-operate-add" @click="addBankItem">新增</span>
                <span class="sub-operate-add" @click="delBankItem(index)">删除</span>
              </div>
              <el-row>
                <el-col :span="12">
                  <!-- 账户类型-->
                  <el-form-item label="账户类型" required>
                    <el-select class="w240" size="small" clearable v-model="item.accountType" placeholder="请选择">
                      <el-option
                        v-for="(item, index) in [
                          { label: '基本户', value: '1' },
                          { label: '一般户', value: '2' },
                          { label: '开票户', value: '3' },
                          { label: '打款户', value: '4' },
                        ]"
                        :key="index"
                        :label="item.label"
                        :value="item.value"
                      >
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <!-- 银行名称 -->
                  <el-form-item label="银行名称" required>
                    <el-input
                      class="w240"
                      size="small"
                      type="text"
                      v-model="item.bankName"
                      :maxlength="100"
                      placeholder="请输入"
                    ></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <!-- 银行卡号 -->
                  <el-form-item label="银行卡号" required>
                    <el-input
                      class="w240"
                      size="small"
                      type="text"
                      oninput="value=value.replace(/[^\d\s]/g, '')"
                      v-model="item.bankAccount"
                      placeholder="请输入"
                    ></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
            </div>
          </div>
          <div class="bottom-btn-box">
            <el-button type="defalut" size="small" @click="addBankDialogVisible = false">取消</el-button>
            <!-- 新增公司银行信息 -->
            <el-button type="primary" size="small" @click="saveBankList()">保存</el-button>
          </div>
        </div>
        <!-- end of 银行信息 -->
      </el-dialog>
      <!-- 新增银行信息弹框 end -->
    </el-form>
  </div>
</template>

<script>
import areaJson from '../../assets/js/china_address_v4.js';
export default {
  data() {
    return {
      addBankDialogVisible: false,
      guid: '',
      options: areaJson,
      addressList: [],
      detailAddres: '',
      // 表单字段
      formData: {
        tenantName: '', // 企业名称
        abbreviation: '', // 简称
        contractGuid: '', // 合同guid
        levyEnterprise: {
          establishDate: '', // 公司成立时间
          registeredCapital: '', // 注册资本
          organizationForm: '', // 公司组织形式
          isPaidIn: '', // 是否实缴
          annualReviewState: '', // 证照年审状态
          isAdvanceMoney: '', // 是否垫资
          cooperationTaxRate: '', // 服务费率
          costMoney: '', // 服务费
          cooperationValidityDate: '', // 合同有效期至
          monthMaxMoney: '', // 月度合作上限
          invoiceType: '', // 开票类型
          introducer: '', // 介绍人
          serviceType: '', // 服务类型
          introducerTel: '', // 联系电话
          avgServiceCost: '', // 人均服务费
          taxPaymentCertificateDate: '', // 完税证明
          privateTaxDetailDate: '', // 个税扣缴明细
          isGuarantee: '', // 是否提供担保
        },
        contacts: '', // 业务联系人
        contactTel: '', // 业务联系人电话
        expenseType: null, // 后台没接收这个字段，前端用的
        taxpayerId: '', // !税号
        tel: '', // !公司电话
        address: '', // !公司地址
        bankList: [
          // !公司的银行列表
          {
            accountType: '',
            bankName: '',
            bankAccount: '',
          },
        ],
      },
      // !基础银行lis
      basicBankList: [
        {
          accountType: '',
          bankName: '',
          bankAccount: '',
        },
      ],
      // 关联银行list
      cooperateBank: [],
      // 表单验证规则
      formRules: {
        tenantName: [{ required: true, message: '公司名称必填', trigger: 'change' }],
        contractGuid: [{ required: true, message: '合同名称必填', trigger: 'blur' }],
        contacts: [{ required: true, message: '业务联系人必填', trigger: 'change' }],
        tel: [{ required: true, message: '请输入正确的电话', trigger: 'change' }],
        address: [{ required: true, message: '公司地址必填', trigger: 'change' }],
        taxpayerId: [{ required: true, message: '税号必填', trigger: 'change' }],
        // 'levyEnterprise.cooperationTaxRate': [
        //   { required: true, message: '合作税率必填', trigger: 'blur' }
        // ],
        'levyEnterprise.monthMaxMoney': [{ required: true, message: '月度合作上限必填', trigger: 'blur' }],
        // 'levyEnterprise.serviceType': [
        //   { required: true, message: '服务类型必填', trigger: 'change' }
        // ],
        // 'levyEnterprise.introducer': [
        //   { required: true, message: '介绍人必填', trigger: 'blur' }
        // ],
        // 'levyEnterprise.introducerTel': [
        //   { required: true, message: '介绍人电话必填', trigger: 'blur' }
        // ],
      },
      // 企业下拉选数据
      tenantList: [],
      // 合同下拉选数据
      contractList: [],
      contractVO: {
        tenantName: '', // 签约企业名称
        tenantGuid: '', // 签约企业guid
      },
      // 开票类型下拉选数据 --信息技术服务费发票，市场推广服务费发票
      billingTypeList: [
        {
          text: '信息技术服务费发票',
          value: '1',
        },
        {
          text: '市场推广服务费发票',
          value: '2',
        },
      ],
      // 服务类型下拉选数据
      servesTypeList: [
        {
          text: '代征',
          value: '9904',
        },
        {
          text: '代缴',
          value: '9903',
        },
      ],
      // 完税证明、个税扣缴明细下拉选数据
      monthsList: [
        {
          text: '近3个月',
          value: 3,
        },
        {
          text: '近6个月',
          value: 6,
        },
        {
          text: '近12个月',
          value: 12,
        },
      ],

      // 费用类型下拉选数据
      expenseTypeList: [
        {
          text: 'SAAS服务费率',
          value: '1',
        },
        {
          text: 'SAAS服务费',
          value: '2',
        },
      ],
      expenseTypeObj: {
        1: {
          label: 'SAAS服务费率(%)',
          prop: 'cooperationTaxRate',
        },
        2: {
          label: 'SAAS服务费(万元)',
          prop: 'costMoney',
        },
      },
      // acceptFile: '.xlsx,.xsl,.xls,.xlsm,.doc,.docx,.png,.jpg,.jpeg,.pdf',
      acceptFile: '*',
      tips: '注意：支持所有文件，单个文件大小需 <= 20M',

      // 营业执照文件
      businesslicenseList: [],
      // 代征资质文件
      agentList: [],
      // 完税证明文件
      taxPaymentList: [],
      // 个人扣缴明细文件
      privateTaxList: [],
      // 是否提供担保文件
      isGuaranteeList: [],

      showImgDialog: false,
    };
  },
  created() {
    this.getTenantData(); // 获取企业接口
    // 修改时需要获取详情数据，给表单赋值
    if (this.$route.query.guid) {
      this.guid = this.$route.query.guid;
      this.getDetailDatas(this.guid);
    }
  },
  methods: {
    // todo 打开新增企业基础银行信息弹框
    openBankList() {
      this.addBankDialogVisible = true;
      this.getBankList();
    },
    // todo 企业基础银行信息保存
    saveBankList() {
      // !银行信息校验
      if (this.basicBankList.length > 0) {
        try {
          this.basicBankList.forEach((item) => {
            if (!item.accountType) {
              throw new Error('账户类型不能为空');
            }
            if (!item.bankName) {
              throw new Error('银行名称不能为空');
            }
            if (!item.bankAccount) {
              throw new Error('银行卡号不能为空');
            }
          });
        } catch (e) {
          this.$message.error(e.message);
          return;
        }
      }

      let repetitionArr = this.findRepeatBank(); // todo 查找重复的银行卡号
      if (repetitionArr.length) {
        let item = repetitionArr[0];
        this.$message.error(`新增银行卡号:[${item.bankAccount}]不能重复，请确认!`);
        return;
      }

      let param = {
        guid: this.formData.tenantGuid,
        tenantName: this.formData.tenantName,
        bankList: this.basicBankList,
        enterpriseCate: '9904',
      };
      this.api.put(`/${serverConfig.msCustomerService}/tenant/data/update`, param).then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          this.$message.success('保存成功');
          this.getCooperateBankList(); // todo 重新获取关联的银行列表

          this.addBankDialogVisible = false;
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
    // todo 获取企业基础银行列表
    getBankList() {
      this.cooperateBank = [];
      let { tenantGuid } = this.formData;
      let that = this;
      this.api
        .get(`/${serverConfig.msCustomerService}/tenant/data/get-tenant-detail?guid=` + tenantGuid)
        .then((res) => {
          const { data } = res;
          if (data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            let datas = data.data;

            //银行信息
            if (datas.bankList && datas.bankList.length) {
              this.$set(this, 'basicBankList', datas.bankList);
            } else {
              let bankList = [
                {
                  //银行信息
                  accountType: null,
                  bankName: null,
                  bankAccount: null,
                },
              ];
              this.$set(this, 'basicBankList', bankList);
            }
            this.cooperateBank = JSON.parse(JSON.stringify(this.basicBankList));
          } else {
            this.$message.error(res.data.msg);
          }
        });
    },
    // todo 获取公司关联服务商的银行列表
    getCooperateBankList() {
      let { tenantGuid } = this.formData;
      let serviceTenantGuid = this.contractVO.tenantGuid;
      let that = this;
      this.api
        .postJson(
          `/${serverConfig.msCustomerService}/tenant/data/get-tenant-service-bank-list?tenantGuid=${tenantGuid}&serviceTenantGuid=${serviceTenantGuid}`,
        )
        .then((res) => {
          const { data } = res;
          if (data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            let datas = data.data;
            //银行信息
            if (datas && datas.length) {
              datas.forEach((item) => {
                item.accountTypeName = this.accountTypeFilter(item.accountType);
              });
              this.$set(this.formData, 'bankList', datas);
            } else {
              let bankList = [
                {
                  //银行信息
                  accountType: null,
                  bankName: null,
                  bankAccount: null,
                },
              ];
              this.$set(this.formData, 'bankList', bankList);
            }
          } else {
            this.$message.error(res.data.msg);
          }
        });
    },
    // todo 获取代征公司的详情
    getDetailDatas(guid) {
      let that = this;
      let formData = {};
      that.api.get(`/${serverConfig.msCustomerService}/levyEnterpriseCredential/detail/${guid}`).then((resp) => {
        const { data } = resp;
        if (data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          let datas = data.data || that.formData;
          let { tenantVO } = datas;
          formData['guid'] = guid;
          formData['tenantGuid'] = datas['tenantGuid'];
          // 获取合同下拉选数据
          that.getContractData(datas['tenantGuid'], function () {
            that.getTenantName(datas['contractGuid']);
          });

          formData['tenantName'] = datas['tenantName'];
          formData['enterpriseCate'] = datas['enterpriseCate'];
          formData['contractGuid'] = datas['contractGuid']; // 合同编号
          formData['taxpayerId'] = tenantVO['taxpayerId']; // 税号
          formData['address'] = tenantVO['address']; // 企业地址
          formData['tel'] = tenantVO['tel']; // 公司电话
          formData['province'] = tenantVO['province'];
          formData['city'] = tenantVO['city'];
          formData['district'] = tenantVO['district'];

          // 填充地址
          if (!formData['province']) {
            this.addressList = [];
          } else {
            this.addressList = [formData.province, formData.city, formData.district];
          }

          formData['expenseType'] = null;

          formData['levyEnterprise'] = {
            tenantGuid: datas['tenantGuid'], // 企业guid
            establishDate: datas['establishDate'], // 公司成立时间
            registeredCapital: datas['registeredCapital'], // 注册资本
            organizationForm: datas['organizationForm'], // 公司组织形式
            isPaidIn: datas['isPaidIn'], // 是否实缴
            annualReviewState: datas['annualReviewState'], // 证照年审状态
            isAdvanceMoney: datas['isAdvanceMoney'], // 是否垫资
            cooperationTaxRate: datas['cooperationTaxRate'], // 合作税率
            costMoney: datas['costMoney'], // 固定金额
            cooperationValidityDate: datas['cooperationValidityDate'], // 合同有效期至
            monthMaxMoney: datas['monthMaxMoney'], // 月度合作上限
            invoiceType: datas['invoiceType'] ? datas['invoiceType'].split(',') : null, // 开票类型
            introducer: datas['introducer'], // 介绍人
            serviceType: datas['serviceType'], // 服务类型
            introducerTel: datas['introducerTel'], // 联系电话
            avgServiceCost: datas['avgServiceCost'], // 人均服务费
            taxPaymentCertificateDate: datas['taxPaymentCertificateDate'], // 完税证明
            privateTaxDetailDate: datas['privateTaxDetailDate'], // 个税扣缴明细
            isGuarantee: datas['isGuarantee'], // 是否提供担保
          };

          // 费用类型
          if (datas['cooperationTaxRate'] || datas['cooperationTaxRate'] == 0) {
            formData['expenseType'] = '1';
          }
          if (datas['costMoney'] || datas['costMoney'] == 0) {
            formData['expenseType'] = '2';
          }

          // 企业实体
          if (datas['tenantVO']) {
            formData['abbreviation'] = datas['tenantVO']['abbreviation'];
            formData['contacts'] = datas['tenantVO']['contacts'];
            formData['contactTel'] = datas['tenantVO']['contactTel'];
          }

          // 营业执照文件
          if (datas['businessLicenseUrl']) {
            let file = datas['businessLicenseUrl'].split('/');
            that.businesslicenseList = [
              {
                name: file[file.length - 1],
                path: datas['businessLicenseUrl'],
              },
            ];
          }

          // 代征资质文件
          if (datas['qualificationUrl']) {
            let file = datas['qualificationUrl'].split('/');
            that.agentList = [
              {
                name: file[file.length - 1],
                path: datas['qualificationUrl'],
              },
            ];
          }

          // 完税证明文件
          if (datas['taxPaymentCertificateUrl']) {
            let file = datas['taxPaymentCertificateUrl'].split('/');
            that.taxPaymentList = [
              {
                name: file[file.length - 1],
                path: datas['taxPaymentCertificateUrl'],
              },
            ];
          }

          // 个人扣缴明细文件
          if (datas['privateTaxDetailUrl']) {
            let file = datas['privateTaxDetailUrl'].split('/');
            that.privateTaxList = [
              {
                name: file[file.length - 1],
                path: datas['privateTaxDetailUrl'],
              },
            ];
          }

          // 是否提供担保文件
          if (datas['guaranteeUrl']) {
            let file = datas['guaranteeUrl'].split('/');
            that.isGuaranteeList = [
              {
                name: file[file.length - 1],
                path: datas['guaranteeUrl'],
              },
            ];
          }

          that.$set(that, 'formData', formData);

          this.getBankList(guid); // !获取企业基础银行列表
          // console.log('-----------')
          // console.log(that.formData)
        }
      });
    },
    // todo 选择合作银行change 公司银行信息列表 bankGuid 关联银行的索引 index
    selectBank(bankGuid, index) {
      try {
        let bankItem = this.cooperateBank.find((item) => item.guid === bankGuid);
        let cooperateBank = this.formData.bankList[index];
        cooperateBank.accountType = bankItem.accountType;
        cooperateBank.accountTypeName = this.accountTypeFilter(bankItem.accountType);
        cooperateBank.bankAccount = bankItem.bankAccount;
        cooperateBank.bankName = bankItem.bankName;
        cooperateBank.guid = bankItem.guid;
      } catch (error) {
        console.error(error.message);
      }
    },
    /**
     * 修改合同时，将签约企业带出来
     * @param {*} val
     */
    changeContract(val) {
      this.getTenantName(val);
    },
    /**
     * 获取签约企业名称
     * @param {*} guid
     */
    getTenantName(guid) {
      let list = this.contractList.filter((item) => {
        return item.guid == guid;
      });
      let datas = list[0];
      console.log(datas);
      this.contractVO['tenantName'] = datas['tenantName'];
      this.contractVO['tenantGuid'] = datas['tenantGuid'];
      this.getCooperateBankList(); // !获取企业关联的银行信息
    },
    /**
     * 获取企业数据
     */
    getTenantData() {
      let that = this;
      that.api
        .postJson(`/${serverConfig.msCustomerService}/tenant/data/get`, {
          // 企业分类(00 平台；0101 医药生产；010201 商业流通公司；010203 COS企业；9901 运营公司；9902 劳务公司；9903 代缴公司；9904 代征公司对应mf_enterprise_cate表中的值)
          enterpriseCate: '9904',
          // 'enterpriseCates': ['9903', '9904'],
          pageIndex: 1,
          pageSize: -1,
        })
        .then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            // console.log(res.data)
            this.tenantList = res.data.data.records || [];
          } else {
            this.$message.error(res.data.msg);
          }
        });
    },
    /**
     * 更改企业时，需要将其他数据带出来
     * @param {*} guid
     */
    changeTenant(guid) {
      // 获取企业详情
      this.getTenantDetailData(guid);
      // 获取企业关联的合同数据
      this.formData.contractGuid = null;
      this.getContractData(guid);
    },
    /**
     * 更改企业时，需要获取对应的合同数据
     * @param {*} guid
     */
    getContractData(guid, fn) {
      this.api
        .postJson(`/${serverConfig.msCustomerService}/contract/list`, {
          pageIndex: 1,
          pageSize: -1,
          serviceTenantGuid: guid, // 乙方企业GUID
          approveState: 'Y', // U不审批 N审批初始状态 Y已通过 R驳回 C撤销
        })
        .then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            // console.log(res.data)
            this.contractList = res.data.data.records || [];
            if (fn) fn();
          } else {
            this.$message.error(res.data.msg);
          }
        });
    },
    /**
     * 修改费用类型
     */
    expenseTypeChange(val) {
      // console.log(val)
      if (val == '1') {
        this.formData['levyEnterprise']['costMoney'] = '';
      }
      if (val == '2') {
        this.formData['levyEnterprise']['cooperationTaxRate'] = '';
      }
    },
    /**
     * 获取企业表单数据
     */
    getTenantDetailData(guid) {
      let that = this;
      let formData = {};
      that.api.get(`/${serverConfig.msCustomerService}/tenant/data/get-tenant-detail?guid=` + guid).then((resp) => {
        const { data } = resp;
        if (data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          let datas = data.data || that.formData;
          formData['tenantGuid'] = datas['guid'];
          formData['tenantName'] = datas['tenantName'];
          formData['abbreviation'] = datas['abbreviation'];
          formData['contacts'] = datas['contacts'];
          formData['contactTel'] = datas['contactTel'];
          formData['enterpriseCate'] = datas['enterpriseCate'];
          formData['expenseType'] = null;
          formData['contractGuid'] = datas['contractGuid']; // 合同编号
          formData['taxpayerId'] = datas['taxpayerId']; // 税号
          formData['address'] = datas['address']; // 企业地址
          formData['tel'] = datas['tel']; // 公司电话
          formData['province'] = datas['province'];
          formData['city'] = datas['city'];
          formData['district'] = datas['district'];

          // 填充地址
          if (!formData['province']) {
            this.addressList = [];
          } else {
            this.addressList = [formData.province, formData.city, formData.district];
          }

          // todo 获取银行列表
          formData.bankList = [
            // !公司的银行列表
            {
              accountType: '',
              bankName: '',
              bankAccount: '',
            },
          ];
          // !代征平台数据
          if (!datas['levyEnterprise']) {
            formData['levyEnterprise'] = {
              tenantGuid: datas['guid'], // 公司成立时间
              establishDate: null, // 公司成立时间
              registeredCapital: null, // 注册资本
              organizationForm: null, // 公司组织形式
              isPaidIn: null, // 是否实缴
              annualReviewState: null, // 证照年审状态
              isAdvanceMoney: null, // 是否垫资
              cooperationTaxRate: null, // 合作税率
              costMoney: null, // 固定金额
              cooperationValidityDate: null, // 合同有效期至
              monthMaxMoney: null, // 月度合作上限
              invoiceType: null, // 开票类型
              introducer: null, // 介绍人
              serviceType: datas['enterpriseCate'], // 服务类型
              introducerTel: null, // 联系电话
              avgServiceCost: null, // 人均服务费
              taxPaymentCertificateDate: null, // 完税证明
              privateTaxDetailDate: null, // 个税扣缴明细
              isGuarantee: null, // 是否提供担保
            };
          } else {
            formData['levyEnterprise'] = datas['levyEnterprise'];

            // 代征代缴类型
            if (datas['levyEnterprise']['serviceType']) {
              formData['enterpriseCate'] = datas['levyEnterprise']['serviceType'];
            } else {
              formData['enterpriseCate'] = datas['enterpriseCate'];
              formData['levyEnterprise']['serviceType'] = datas['enterpriseCate'];
            }

            // 开票类型存在数据库是字符串，取值得时候需要转换成数组
            if (datas['levyEnterprise']['invoiceType']) {
              formData['levyEnterprise']['invoiceType'] = datas['levyEnterprise']['invoiceType'].split(',');
            }

            // 营业执照文件
            if (datas['levyEnterprise']['businessLicenseUrl']) {
              let file = datas['levyEnterprise']['businessLicenseUrl'].split('/');
              that.businesslicenseList = [
                {
                  name: file[file.length - 1],
                  path: datas['levyEnterprise']['businessLicenseUrl'],
                },
              ];
            }

            // 代征资质文件
            if (datas['levyEnterprise']['qualificationUrl']) {
              let file = datas['levyEnterprise']['qualificationUrl'].split('/');
              that.agentList = [
                {
                  name: file[file.length - 1],
                  path: datas['levyEnterprise']['qualificationUrl'],
                },
              ];
            }

            // 完税证明文件
            if (datas['levyEnterprise']['taxPaymentCertificateUrl']) {
              let file = datas['levyEnterprise']['taxPaymentCertificateUrl'].split('/');
              that.taxPaymentList = [
                {
                  name: file[file.length - 1],
                  path: datas['levyEnterprise']['taxPaymentCertificateUrl'],
                },
              ];
            }

            // 个人扣缴明细文件
            if (datas['levyEnterprise']['privateTaxDetailUrl']) {
              let file = datas['levyEnterprise']['privateTaxDetailUrl'].split('/');
              that.privateTaxList = [
                {
                  name: file[file.length - 1],
                  path: datas['levyEnterprise']['privateTaxDetailUrl'],
                },
              ];
            }

            // 是否提供担保文件
            if (datas['levyEnterprise']['guaranteeUrl']) {
              let file = datas['levyEnterprise']['guaranteeUrl'].split('/');
              that.isGuaranteeList = [
                {
                  name: file[file.length - 1],
                  path: datas['levyEnterprise']['guaranteeUrl'],
                },
              ];
            }

            // 费用类型
            if (datas['levyEnterprise']['cooperationTaxRate'] || datas['levyEnterprise']['cooperationTaxRate'] == 0) {
              formData['expenseType'] = '1';
            }
            if (datas['levyEnterprise']['costMoney'] || datas['levyEnterprise']['costMoney'] == 0) {
              formData['expenseType'] = '2';
            }
          }
          that.$set(that, 'formData', formData);
          this.getBankList();
          // !获取企业关联的银行信息
          // console.log('-----------')
          // console.log(that.formData)
        }
      });
    },
    /**
     * 提交表单
     */
    submitForm() {
      let that = this;
      let { formData } = this;
      let postData = JSON.parse(JSON.stringify(formData));

      // 费用类型
      // if(postData['levyEnterprise'] && formData.expenseType == '1' && !postData['levyEnterprise']['cooperationTaxRate']) {
      //   return this.$message.warning('请填写SAAS服务费率')
      // }
      // if(postData['levyEnterprise'] && formData.expenseType == '2' && !postData['levyEnterprise']['costMoney']) {
      //   return this.$message.warning('请填写SAAS服务费')
      // }

      // if(postData['levyEnterprise'] && postData['levyEnterprise']['serviceType'] == '9903' && !postData['levyEnterprise']['avgServiceCost']) {
      //   return this.$message.warning('如果服务类型为代缴，则需要填写人均服务费')
      // }

      // 开票类型存在数据库是字符串
      if (postData['levyEnterprise'] && postData['levyEnterprise']['invoiceType']) {
        postData['levyEnterprise']['invoiceType'] = postData['levyEnterprise']['invoiceType'].toString();
      }

      // 代征代缴类型
      postData['enterpriseCate'] = postData['levyEnterprise']['serviceType'];

      // 是否提供担保，如果不提供担保，则将担保附件清空
      if (postData['levyEnterprise'] && postData['levyEnterprise']['isGuarantee'] == 'N') {
        postData['levyEnterprise']['guaranteeUrl'] = '';
      }

      // !银行信息校验
      if (this.formData.bankList.length > 0) {
        try {
          this.formData.bankList.forEach((item) => {
            if (!item.accountType) {
              throw new Error('账户类型不能为空');
            }
            if (!item.bankName) {
              throw new Error('银行名称不能为空');
            }
            if (!item.bankAccount) {
              throw new Error('银行卡号不能为空');
            }
          });
        } catch (e) {
          this.$message.error(e.message);
          return;
        }
      }

      this.$refs['formData'].validate((valid, error) => {
        if (valid) {
          if (that.guid) {
            return that.editData(postData);
          }
          that.addData(postData);
        } else {
          if (error && Object.keys(error).length) {
            let message = error[Object.keys(error)[0]][0].message;
            message && this.$message.error(message);
          }
          console.log('error submit!!');
          return false;
        }
      });
    },
    addData(postData) {
      let that = this;
      postData.serviceTenantGuid = this.contractVO.tenantGuid;
      that.api.postJson(`/${serverConfig.msCustomerService}/levyEnterpriseCredential/add`, postData).then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          that.$message.success('保存成功');
          this.$router.go(-1);
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
    editData(postData) {
      let that = this;
      postData.serviceTenantGuid = this.contractVO.tenantGuid;
      that.api.put(`/${serverConfig.msCustomerService}/levyEnterpriseCredential/update`, postData).then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          that.$message.success('保存成功');
          this.$router.go(-1);
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
    /**
     * 上传营业执照文件-导入
     */
    uploadBusinesslicense(file) {
      let self = this;
      self.uploadData(file, function (status, res) {
        console.log(status);
        // status 1上传成功  2上传失败
        if (status == 1) {
          self.businesslicenseList.push({
            name: file.file.name,
            path: res.data.data.data,
          });
          // 营业执照路径赋值
          self.formData.levyEnterprise['businessLicenseUrl'] = res.data.data.data;
          return;
        }
        if (status == 2) {
          self.removeBusinessList();
        }
      });
    },
    /**
     * 上传代征资质文件-导入
     */
    uploadAgent(file) {
      let self = this;
      self.uploadData(file, function (status, res) {
        // status 1上传成功  2上传失败
        if (status == 1) {
          self.agentList.push({
            name: file.file.name,
            path: res.data.data.data,
          });
          // 代征资质路径赋值
          self.formData.levyEnterprise['qualificationUrl'] = res.data.data.data;
        }
        if (status == 2) {
          self.removeAgentList();
        }
      });
    },
    /**
     * 上传完税证明文件-导入
     */
    uploadTaxPayment(file) {
      let self = this;
      self.uploadData(file, function (status, res) {
        // status 1上传成功  2上传失败
        if (status == 1) {
          self.taxPaymentList.push({
            name: file.file.name,
            path: res.data.data.data,
          });
          // 完税证明路径赋值
          self.formData.levyEnterprise['taxPaymentCertificateUrl'] = res.data.data.data;
        }
        if (status == 2) {
          self.removeTaxPaymentList();
        }
      });
    },
    /**
     * 上传个人扣缴明细文件-导入
     */
    uploadPrivateTax(file) {
      let self = this;
      self.uploadData(file, function (status, res) {
        // status 1上传成功  2上传失败
        if (status == 1) {
          self.privateTaxList.push({
            name: file.file.name,
            path: res.data.data.data,
          });
          // 个人扣缴明细路径赋值
          self.formData.levyEnterprise['privateTaxDetailUrl'] = res.data.data.data;
        }
        if (status == 2) {
          self.removePrivateTaxList();
        }
      });
    },
    /**
     * 上传是否提供承担文件-导入
     */
    uploadIsGuarantee(file) {
      let self = this;
      self.uploadData(file, function (status, res) {
        // status 1上传成功  2上传失败
        if (status == 1) {
          self.isGuaranteeList.push({
            name: file.file.name,
            path: res.data.data.data,
          });
          // 承担文件路径赋值
          self.formData.levyEnterprise['guaranteeUrl'] = res.data.data.data;
        }
        if (status == 2) {
          self.removeIsGuaranteeList();
        }
      });
    },
    /**
     * 附件上传方法
     * @param {*} file
     * @param {*} fn
     */
    uploadData(file, fn) {
      let self = this;
      console.log(file);
      let formData = new FormData();
      formData.append('file', file.file);
      formData.append('fileName', file.file.name);
      self.api
        .postImage(`/${serverConfig.msCommonAdminCloudService}/obs/upload-file-include-filename`, formData)
        .then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            // 成功回调
            if (fn) fn(1, res);
            self.$message({
              message: '上传成功',
              type: 'success',
            });
          } else {
            // 失败回调
            if (fn) fn(2, res);
            self.$message.error('上传失败!');
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    /**
     * 移除营业执照文件
     */
    removeBusinessList() {
      this.businesslicenseList = [];
      this.formData.levyEnterprise['businessLicenseUrl'] = '';
    },
    /**
     * 移除代征资质文件
     */
    removeAgentList() {
      this.agentList = [];
      this.formData.levyEnterprise['qualificationUrl'] = '';
    },
    /**
     * 移除完税证明文件
     */
    removeTaxPaymentList() {
      this.taxPaymentList = [];
      this.formData.levyEnterprise['taxPaymentCertificateUrl'] = '';
    },
    /**
     * 移除个人扣缴明细文件
     */
    removePrivateTaxList() {
      this.privateTaxList = [];
      this.formData.levyEnterprise['privateTaxDetailUrl'] = '';
    },
    /**
     * 移除是否提供承担文件
     */
    removeIsGuaranteeList() {
      this.isGuaranteeList = [];
      this.formData.levyEnterprise['guaranteeUrl'] = '';
    },
    handleExceed(files, fileList) {
      this.$message.warning(`当前限制选择 1 个文件`);
    },
    /**
     * 上传前校验
     */
    beforeAvatarUpload(file) {
      var fileSuffix = file.name ? file.name.substring(file.name.lastIndexOf('.') + 1) : '';
      const isJPG =
        fileSuffix === 'xlsx' ||
        fileSuffix === 'xsl' ||
        fileSuffix === 'xls' ||
        fileSuffix === 'xlsm' ||
        fileSuffix === 'doc' ||
        fileSuffix === 'docx' ||
        fileSuffix === 'png' ||
        fileSuffix === 'jpeg' ||
        fileSuffix === 'jpg' ||
        fileSuffix === 'pdf';

      const isLt5M = file.size / 1024 / 1024 < 20;
      // if (!isJPG) {
      //   this.$message.error('文件格式不正确!');
      // }
      if (!isLt5M) {
        this.$message.error('文件大小不能超过20MB!');
      }
      return isJPG && isLt5M;
    },
    /**
     * 查看文件
     * @param {*} url
     * @param {*} name 图片名称
     */
    seeDetail(url, name) {
      var fileSuffix = name ? name.substring(name.lastIndexOf('.') + 1) : '';
      if (fileSuffix === 'png' || fileSuffix === 'jpeg' || fileSuffix === 'jpg' || fileSuffix === 'pdf') {
        return window.open(url, name);
      }
      window.open('https://view.officeapps.live.com/op/view.aspx?src=' + encodeURIComponent(url));
    },
    //新增基础银行信息
    addBankItem() {
      this.basicBankList.push({
        accountType: null,
        bankName: null,
        bankAccount: null,
      });
    },
    //删除银行
    delBankItem(index) {
      this.basicBankList.splice(index, 1);
    },
    //新增合作银行信息银行
    addCooperateBankItem() {
      this.formData.bankList.push({
        accountType: null,
        bankName: null,
        bankAccount: null,
      });
    },
    //新增合作银行信息银行
    delCooperateBankItem(index) {
      this.formData.bankList.splice(index, 1);
    },
    addressChange(val) {
      if (val && val.length) {
        this.formData.address = `${val.join('')}${this.formData.address || ''}`;
      }
    },
    checkPhone(value) {
      let { formData } = this;
      if (/^((0\d{2,3}-\d{7,8})|(1[3456789]\d{9}))$/.test(value)) {
        formData.tel = value;
      } else {
        formData.tel = '';
      }
    },
    accountTypeFilter(val) {
      if (!val) {
        return '-';
      }
      switch (val) {
        case '1':
          return '基本户';
        case '2':
          return '一般户';
        case '3':
          return '开票户';
        case '4':
          return '打款户';
      }
    },
    incres(area) {
      this.formData.province = area[0];
      this.formData.city = area[1];
      this.formData.district = area[2];
      let venue = '';
      if (area) {
        if (area[0]) {
          venue = this.province(area[0]);
        }
        if (area[1]) {
          venue = this.province(area[0]) + '/' + this.city(area[1]);
        }
        if (area[2]) {
          venue = this.province(area[0]) + '/' + this.city(area[1]) + '/' + this.district(area[2]);
        }
      }
      this.formData.venue = venue;
    },
    province(val) {
      let pr = '';
      this.options.forEach(function (j) {
        if (j.value == val) {
          pr = j.label;
        }
      });
      return pr;
    },
    city(val) {
      let ci = '';
      this.options.forEach(function (i) {
        if (i.children != null && i.children != '') {
          i.children.forEach(function (j) {
            if (j.value == val) {
              ci = j.label;
            }
          });
        }
      });
      return ci;
    },
    district(val) {
      let di = '';
      this.options.forEach(function (i) {
        if (i.children != null && i.children != '') {
          i.children.forEach(function (j) {
            if (j.children != null && j.children != '') {
              j.children.forEach(function (n) {
                if (n.value == val) {
                  di = n.label;
                }
              });
            }
          });
        }
      });
      return di;
    },
    // todo 查找重复的银行
    findRepeatBank() {
      let deWeightArr = []; // 去重后的数组
      let repetitionArr = []; // 重复的数组
      this.basicBankList.forEach((item1) => {
        const check = deWeightArr.every((item2) => {
          return item1.bankAccount !== item2.bankAccount;
        });
        check ? deWeightArr.push(item1) : repetitionArr.push(item1);
      });
      console.log('重复的数据================>>>>>', repetitionArr);
      return repetitionArr;
    },
  },
};
</script>
<style lang="less" scoped>
.content {
  padding: 0px;
  margin: 0px;
  .title-box {
    border-top: 1px solid #e5e5e5;
    background-color: #ffffff;
    padding: 8px 0px;
    position: relative;
    button {
      font-size: 12px;
      color: #212121;
      letter-spacing: 0;
      width: 60px;
      height: 26px;
      padding: 0px;
      border: 1px solid rgba(217, 217, 217, 1);
      border-radius: 2px;
      position: absolute;
      left: 16px;
      top: 6px;
    }
    span {
      text-align: center;
      font-size: 16px;
      font-weight: 400;
    }
  }
  .form-box {
    margin-top: 4px;
    text-align: left;
    .form-box-title {
      display: flex;
      justify-content: space-between;
    }
    .form-title {
      height: 40px;
      line-height: 40px;
      font-size: 16px;
      margin-left: 16px;
    }
    .form-item-box {
      width: 90%;
      margin: 0 auto;
    }
    // .el-col-12 {
    //   height: 50px;
    // }
    .el-form-item {
      margin-bottom: 8px;
    }
    .el-input,
    .el-select {
      width: 314px;
    }
    .age-are-box {
      display: flex;
      align-items: center;
      .el-input {
        width: 142px;
      }
      span {
        margin: 0px 8px;
      }
    }
    .bottom-btn-box {
      padding: 18px 0px;
      text-align: center;
      border-top: 1px solid #e5e5e5;
    }
  }

  .form-box-add {
    margin-top: 4px;
    text-align: left;

    .form-title {
      height: 40px;
      line-height: 40px;
      font-size: 16px;
      margin-left: 16px;
    }
    .bank-list {
      max-height: 500px;
      overflow-y: auto;
    }
    .form-item-box {
      width: 90%;
      margin: 0 auto;
    }
    // .el-col-12 {
    //   height: 50px;
    // }
    .el-form-item {
      margin-bottom: 8px;
    }
    .el-input,
    .el-select {
      width: 314px;
    }
    .age-are-box {
      display: flex;
      align-items: center;
      .el-input {
        width: 142px;
      }
      span {
        margin: 0px 8px;
      }
    }
    .bottom-btn-box {
      padding: 18px 0px;
      text-align: center;
      border-top: 1px solid #e5e5e5;
    }
  }

  /deep/ .el-form-item__error {
    padding-top: 0px;
  }
  .el-button--primary {
    color: #ffffff;
  }

  .file-list-box {
    display: flex;
    // justify-content: space-between;
    align-items: flex-end;
    margin-bottom: 32px;
    .upload-file-box {
      max-width: calc(100% - 132px - 16px);
    }
    .btn-box {
      width: 132px;
      margin-left: 16px;
      height: 32px;
    }
  }
  .sub-operate-add {
    color: #4fa1a4;
    margin-left: 14px;
    cursor: pointer;
  }
}
/deep/ .el-upload__tip {
  line-height: 1;
  margin-top: 8px;
}
/deep/ .el-upload-list__item:first-child {
  margin-top: 8px;
}
</style>
